// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter, Link} from 'react-router-dom';
import {BreadCrumb} from 'primereact/breadcrumb';
import searchHoc from '../components-app/search-wrapper';

const servicesDataKey = 'loadHomeShelf';

const styles = {main: {marginTop: 10, marginBottom: 10, width: 'auto'}, breadcrumb: {border: '1px solid white'}};
const homeShelfPath = '/sub-shelves/homeShelf';
const home = {icon: 'pi pi-home', url: homeShelfPath};

class SubShelfBreadcrumbs extends Component {
    fetchBreadcrumbs = () => {
        const {matchUrl, searchData} = this.props;
        const breadcrumbs = [];

        // Define homeShelf path URL.
        const homeShelfPath = '/sub-shelves/homeShelf';
        const homeShelfPathLength = homeShelfPath.length;

        if (matchUrl === '/sub-shelves/homeShelf') {
            breadcrumbs.push({});
        } else if (matchUrl.includes('/sub-shelves/homeShelf')) {
            const shelfIdsUrl = matchUrl.substring(homeShelfPathLength + 1);
            const shelfIds = shelfIdsUrl.split('/');
            let path = homeShelfPath;
            breadcrumbs.push({});

            if (searchData.ShelfDTO) {
                let nextShelfNode = searchData.ShelfDTO;
                shelfIds.forEach(shelfId => {
                    path = path + '/' + shelfId;

                    if (nextShelfNode != null) {
                        const shelfIdMatch = nextShelfNode.subShelves.filter(
                            shelf => shelf.ShelfDTO.id == Number(shelfId)
                        );

                        if (shelfIdMatch.length > 0) {
                            nextShelfNode = shelfIdMatch[0].ShelfDTO;

                            breadcrumbs.push({
                                label: shelfIdMatch[0].ShelfDTO.name,
                                url: path,
                            });
                        } else {
                            breadcrumbs.push({
                                label: 'Shelf Not Found ID: ' + shelfId,
                                url: path,
                            });
                            nextShelfNode = null;
                        }
                    }
                });
            }
        }

        return breadcrumbs;
    };

    render() {
        const {error} = this.props;

        const crumbs = this.fetchBreadcrumbs();
        if (error) {
            return <p>Breadcrumb Error: {error}</p>;
        }
        if (crumbs.length <= 0) {
            return {};
        }
        return (
            <div style={styles.main}>
                <BreadCrumb home={home} model={crumbs.filter(c => c && c.label)} style={styles.breadcrumb} />
            </div>
        );
    }
}

SubShelfBreadcrumbs.propTypes = {
    error: PropTypes.string,
    matchUrl: PropTypes.string,
    searchData: PropTypes.object.isRequired,
};

export default withRouter(searchHoc(SubShelfBreadcrumbs, servicesDataKey));
